import * as opalModern from '@monolith/app_root/modern/application.ts'

window.opalModern = opalModern
